const repeaterDictionary = {
  repeater: {
    emptyMessage: {
      text: "There is nothing here. Try adding a new item."
    },
    addButton: {
      text: "Add"
    }
  }
};
export {
  repeaterDictionary
};
//# sourceMappingURL=repeaterDictionary.js.map
